//Badge Claim Codes Manager

let ClaimCodeActions = Reflux.createActions([
    'fetchClaimCodes'
]);

class ClaimCodeStore extends Reflux.Store {
    constructor() {
        super();
        this.state = {
            claimcodes: []
        };
        this.listenables = ClaimCodeActions;
    }

    onFetchClaimCodes(orgid,badgeid) {
        let _self = this;
        httpGet(buildRoute(mantlroutes.claim_codes,{ orgid: orgid, badgeid: badgeid })).then(
            function(value) {
                var response = JSON.parse(value);
                // console.log(response);
                _self.setState({ claimcodes: response });
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Retrieve Claim Codes')
            });
    }

}


class ClaimCodeManager {
    constructor(options) {
        this.defaults = {
            orgid: null,
            badgeid: null,
            target: null,
            root: 'https://mymantl.com/claim/'
        }
        this.settings = extend( {}, this.defaults, options );
        this.Actions = ClaimCodeActions;
        this.render();
        this.initStore();
    }

    render() {
        let target = this.settings.target;
        ReactDOM.render(<ClaimCodeListWrapper settings={this.settings} />, document.getElementById(target));
    }

    initStore() {
        this.Actions.fetchClaimCodes(this.settings.orgid, this.settings.badgeid);
    }

}

//Reflux.Component extends React.Component
class ClaimCodeListWrapper extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = new ClaimCodeStore(); // <- just assign the store class itself
        this.getItems = this.getItems.bind(this);
        this.handleNew = this.handleNew.bind(this);
    }

    getItems() {
        let claimcodes = [];
        this.state.claimcodes.forEach((element,index) => {
            claimcodes.push( <ClaimCodeListItem key={"key_"+element.id} settings={this.props.settings} id={element.id} code={element.code} description={element.description} active={element.active} evidence={element.evidence} created={element.created} /> );
        });
        return claimcodes;
    }

    handleNew(){

    }

    render() {
        var count = this.state.claimcodes.length;
        let claimcodes = this.getItems();

        if(count > 0){
            return (
                <section className="claimcodes">
                    <ul className="collection">{claimcodes}</ul>
                    <ClaimCodeAdd settings={this.props.settings} />
                </section>
            );
        } else {
            return (
                <section className="claimcodes">
                    <p className="text--center text--xl text--muted">You haven't generated any claim codes yet.</p>
                    <ClaimCodeAdd settings={this.props.settings} />
                </section>
            );
        }

    }
}

class ClaimCodeListItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleActivate = this.handleActivate.bind(this);
        this.handleDeactivate = this.handleDeactivate.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSaveDescription = this.handleSaveDescription.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.state = {
            editing: false
        };
    }

    handleDelete(){
        var component = ReactDOM.findDOMNode(this);
        let endpoint = buildRoute(mantlroutes.claim_code,{ orgid: this.props.settings.orgid, badgeid: this.props.settings.badgeid, claimcodeid: this.props.id })
        let _self = this;
        alertify.okBtn("Yes, Delete").cancelBtn("Cancel").confirm("<h1 class='h3'>Are you sure you want to <b class='text--danger'>delete</b> this claim code?</h1>")
        .then(function (resolvedValue) {
            resolvedValue.event.preventDefault();
            if(resolvedValue.buttonClicked == "ok"){
                httpDelete(endpoint).then(
                    function(value){
                        ClaimCodeActions.fetchClaimCodes(_self.props.settings.orgid, _self.props.settings.badgeid);
                        alertify.log("Deleted")
                    })
                .catch(
                    function(reason) {
                        console.error(reason);
                        alertify.error("Unable to delete claim code.");
                    });
            } else {
                alertify.log("Cancelled")
            }
        });
    }

    handleActivate(){
        let endpoint = buildRoute(mantlroutes.claim_code,{ orgid: this.props.settings.orgid, badgeid: this.props.settings.badgeid, claimcodeid: this.props.id })
        let _self = this;
        httpPatch(endpoint, { active: true }).then(
            function(value){
                ClaimCodeActions.fetchClaimCodes(_self.props.settings.orgid, _self.props.settings.badgeid);
                alertify.success("Activated")
            })
        .catch(
            function(reason) {
                alertify.error("Unable to activate claim code.");
            });
    }

    handleDeactivate(){
        let endpoint = buildRoute(mantlroutes.claim_code,{ orgid: this.props.settings.orgid, badgeid: this.props.settings.badgeid, claimcodeid: this.props.id })
        let _self = this;
        httpPatch(endpoint, { active: false }).then(
            function(value){
                ClaimCodeActions.fetchClaimCodes(_self.props.settings.orgid, _self.props.settings.badgeid);
                alertify.log("Deactivated")
            })
        .catch(
            function(reason) {
                alertify.error("Unable to activate claim code.");
            });
    }

    handleEdit(){
        this.setState({ editing: true });
    }

    handleSaveDescription() {
        let target = "claimcodedescription_" + this.props.id;
        let newText = document.getElementById(target).value;
        let endpoint = buildRoute(mantlroutes.claim_code,{ orgid: this.props.settings.orgid, badgeid: this.props.settings.badgeid, claimcodeid: this.props.id })
        let _self = this;
        if(newText.length == 0){
            alertify.error("You cannot save a blank description.");
        } else {
            httpPatch(endpoint, { description: newText }).then(
                function(value){
                    ClaimCodeActions.fetchClaimCodes(_self.props.settings.orgid, _self.props.settings.badgeid);
                    alertify.success("Updated");
                    _self.setState({ editing: false });
                })
            .catch(
                function(reason) {
                    alertify.error("Unable to update description.");
                });
        }

    }

    handleCancel() {
        this.setState({ editing: false });
    }

    componentDidMount(){
        let target = "qrcode_" + this.props.id;
        let qrcode = new QRCode(document.getElementById(target), {
        	text: this.props.settings.root + this.props.code,
        	width: 200,
        	height: 200,
        	colorDark : "#000000",
        	colorLight : "#ffffff"
        });
    }

    render() {
        let endorsement = this.props.endorsement;
        let classes = (this.props.active) ? "collection-item" : "collection-item is-disabled";
        return (
            <li className={classes} data-id={this.props.id}>
                <p>
                    <FormattedDate date={this.props.created} />
                    <span className="emspace"> </span>
                    {this.props.active && (
                        <span><i className="icon-check icon--success" aria-hidden="true"></i> Active</span>
                    )}
                    {!this.props.active && (
                        <span><i className="icon-close icon--danger" aria-hidden="true"></i> Deactivated</span>
                    )}
                </p>
                <div className="row">
                    <div className="column-3">
                        <div id={"qrcode_" + this.props.id} className="qrcode-wrapper text--loosebottom"></div>
                    </div>
                    <div className="column-9">
                        <p>
                            {!this.props.active && (
                                <span className="text--xl text--muted">{this.props.settings.root}<kbd className="text--primary">{this.props.code}</kbd></span>
                            )}
                            {this.props.active && (
                                <span className="text--xl text--success">{this.props.settings.root}<kbd className="text--primary">{this.props.code}</kbd></span>
                            )}
                            {this.props.active && (
                                <a href={this.props.settings.root + this.props.code} className="button button--flat button--skinny" title="Claim Page Link"><i className="icon-link"><span className="screenreader">Claim Page Link</span></i></a>
                            )}
                        </p>
                        <p>
                            {this.props.description && !this.state.editing && (
                                <span>{this.props.description}</span>
                            )}
                            {!this.props.description && !this.state.editing && (
                                <span><i>No description given.</i></span>
                            )}
                            {this.state.editing && (
                                <textarea id={"claimcodedescription_" + this.props.id}>{this.props.description}</textarea>
                            )}
                            {!this.state.editing && (
                                <span className="emspace"> </span>
                            )}
                            {!this.state.editing && (
                                <button className="button--sm button--skinny button--flat" onClick={this.handleEdit}><i className="icon-pencil"></i> Edit Description</button>
                            )}
                            {this.state.editing && (
                                <div>
                                    <button className="button--sm button--skinny button--flat" onClick={this.handleSaveDescription}><i className="icon-check icon--success"></i> Save</button>
                                    <button className="button--sm button--skinny button--flat" onClick={this.handleCancel}><i className="icon-close"></i> Cancel</button>
                                </div>
                            )}
                        </p>
                        <hr />
                        <p className="text--loosebottom">
                            {this.props.active && (
                                <button className="button--primary button--skinny" onClick={this.handleDeactivate}>Deactivate</button>
                            )}
                            {!this.props.active && (
                                <button className="button--success button--skinny" onClick={this.handleActivate}>Activate</button>
                            )}
                            &nbsp;
                            <button className="button--flat button--skinny text--danger" onClick={this.handleDelete}>Delete</button>
                        </p>
                    </div>
                </div>

            </li>
        )
    }
}

class ClaimCodeAdd extends React.Component {
    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave() {
        var component = ReactDOM.findDOMNode(this);
        let endpoint = buildRoute(mantlroutes.claim_codes,{ orgid: this.props.settings.orgid, badgeid: this.props.settings.badgeid })
        let description = document.getElementById('claimcode_new').value;
        let _self = this;
        httpPost(endpoint, { description: description }).then(
            function(value){
                alertify.success("Added");
                document.getElementById('claimcode_new').value = "";
                ClaimCodeActions.fetchClaimCodes(_self.props.settings.orgid, _self.props.settings.badgeid);
            })
        .catch(
            function(reason) {
                alertify.error("Unable to generate claimcode.");
            });
    }

    render() {
        return (
            <div className="row">
                <div className="column-6 column-plus3 card card--rounded">
                    <div className="card-content text--center">
                        <div className="input-group input-group--full">
                            <input type="text" id="claimcode_new" name="description" title="Description" placeholder="Where/How will it be used?" />
                            <button type="button" className="preview button--success button--skinny" onClick={this.handleSave}><i className="icon-plus"></i> Generate Code</button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
